import classNames from 'classnames';
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import styles from './Rescue.module.scss';

export function Rescue() {
  const { t } = useTranslation();
  // Also mark email_captured cookie so that Unbounce modals don't display
  const emailCaptured = (
    <img src="https://api.tryfi.com/api/ecommerce/emailcaptured.gif" alt="" style={{ display: 'none' }} />
  );

  return (
    <div className={styles.rescuePage}>
      {emailCaptured}

      <div className={styles.rescueHero}>
        <img src="/rescue_hero.jpg" alt={t('a_dog')} />
      </div>

      <div className={classNames([styles.rescueMain, styles.splitContainer])}>
        <div className={styles.rescueLeft}>
          <h5>{t('welcome')}</h5>
          <h2>{t('fi_partners')}</h2>
          <div>
            <img src="/gift_cards_multi.png" width="92px" alt={t('several_fi_gift_cards')} />
            <p>{t('you_can_use_this_page_to_add_any_number_of_gift_cards')}</p>
          </div>
        </div>
        <div className={styles.rescueRight}>
          <p>
            <Trans
              i18nKey="this_program_has_expired_please_contact"
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              components={{ email: <a href="mailto:rescues@tryfi.com" target="_blank" rel="noopener noreferrer" /> }}
            />
          </p>
        </div>
      </div>
    </div>
  );
}
